import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, X } from "lucide-react";
import { Link } from "react-router-dom";
import { myWallet } from "../../api/wallet";
import { useAuth } from "../../context/AuthContext";
import { isAdmin } from "../../utils/role";
import { IS_STORE_BUILD } from "../../config/storeBuild";

const LEVEL = (balance, [low, critical] = [200, 50]) =>
  balance <= 0 ? "empty" : balance <= critical ? "critical" : balance <= low ? "low" : null;

const DISMISS_KEY = "helcoo_wallet_banner_dismissed";
let cachedWallet = null; // fetched once per app session, home page only

// شريط تنبيه واضح قبل نفاد توكنات التحقق بالوجه — للمدراء فقط، ومخفي في نسخة المتاجر.
export const LowBalanceBanner = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [wallet, setWallet] = useState(cachedWallet);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");
  const allowed = isAdmin(user) && !IS_STORE_BUILD;

  useEffect(() => {
    if (!allowed || cachedWallet) return;
    myWallet()
      .then((res) => {
        cachedWallet = res;
        setWallet(res);
      })
      .catch(() => setWallet(null));
  }, [allowed]);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setHidden(true);
  };

  const balance = wallet ? Number(wallet.balance) : null;
  const level = balance === null ? null : LEVEL(balance, wallet.alert_thresholds);
  if (!allowed || !level || hidden) return null;
  const danger = level !== "low";

  return (
    <div
      data-testid="wallet-low-banner"
      className={`flex flex-wrap items-center gap-3 rounded-2xl border px-4 py-3 shadow-neu-sm ${
        danger ? "border-destructive/40 bg-destructive/10" : "border-amber-500/40 bg-amber-500/10"
      }`}
    >
      <AlertTriangle className={`h-5 w-5 shrink-0 ${danger ? "text-destructive" : "text-amber-500"}`} />
      <p className="min-w-0 flex-1 text-base font-semibold" data-testid="wallet-low-banner-text">
        {t(`wallet.alert.${level}`, { balance })}
      </p>
      <Link
        to="/wallet"
        data-testid="wallet-low-banner-buy"
        className="rounded-2xl bg-primary px-4 py-2 text-sm font-bold text-primary-foreground"
      >
        {t("wallet.alert.buy")}
      </Link>
      <button type="button" data-testid="wallet-low-banner-close" onClick={() => setHidden(true)}>
        <X className="h-4 w-4 text-muted-foreground" />
      </button>
    </div>
  );
};
